export default {
	API_BASE: "https://d1meidkmedcrj5.cloudfront.net/api/"
};
